import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  listroot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '12px',
    height: 72,
    borderBottom: '1px solid #F2F2F2',
  },
  menuroot: {
    boxShadow: '0px 4px 10px rgba(204, 204, 204, 0.5)',
    background: "white"
  },
  weekmonthcontainer: {
    width: "35%",
    display: 'flex',
    flexDirection: 'column',
  },
  rightWrapper: {
    width: "65%",
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 12px"
  },
  monthweekText: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
  },
  time: {
    fontSize: 12,
    lineHeight: '18px',
    color: 'rgba(51, 51, 51, 0.5)',
    marginTop: 0,
  },
  eventname: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
    fontWeight: 600,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  status: {
    fontSize: 14,
    lineHeight: '24px',
    color: "black",
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  btn: {
    width: 150,
    textTransform: "capitalize"
  },
  menuicon: {
    color: '#333',
    "&:hover": {
      color: "#26bbed"
    }
  },
  rsvp: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
    fontWeight: 400,
    '&:hover': {
      color: '#26BBED',
      cursor: 'pointer',
    },
  },

  marginStyle: {
    marginLeft: 17,
  },

  textWrapper: {
    width: '16.66%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textWrapperLarge: {
    width: '20.66%',
    display: 'flex',
    textOverflow: 'ellipsis',
  },
  iconroot: {
    minWidth: 30,
  },
  redico: {
    color: '#E75F75',
  },
  normico: {
    color: '#333',
  },
  menutextred: {
    color: '#E75F75',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.44px',
  },
  menutext: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.44px',
    color: '#333333',
  },
  listbtn: {
    height: 48,
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#eee',
    },

    '&:hover p': {
      color: '#26BBED',
    },
    '&:hover div span i': {
      color: '#26BBED',
    },
  },

  listbtnred: {
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#eee',
    },

    '&:hover p': {
      color: '#E75F75',
    },
    '&:hover div span i': {
      color: '#E75F75',
    },
  },
  noContext: {
    marginLeft: 24,
    width: 24
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  headerCell: {
    fontSize: 12,
    height: 18,
    display: "flex",
    alignItems: "center"
  },
  switchTrack: {
    backgroundColor: "#27bbed !important",
    opacity: "0.8 !important"
  },
  switchThumb: {
    border: "1px solid #27bbed"
  },
  borderTable: {
    border: "1px solid #dbd9d9",
    width: "100%",
    background: '#fff',
  },
  dropDownSelect: {
    color: "rgba(51, 51, 51, 0.5)",
    fontSize: 14,
    width: 97
  },
  dropDownContainer: {
    border: "1px solid #dadada",
    padding: "0px 12px",
    width: 135,
    position: "absolute",
    top: 0,
  },
  menuItem: {
    maxWidth: "45px"
  },
  activeCell: {
    paddingLeft: "22px !important"
  },
  filterCell: {
    position: "relative !important",
    height: 37,
  },
  listBorder: {
    borderTop: "1px solid #dadada"
  },
  popUpTitle: {
    width: 420
  }

}));